import React from 'react';
import Hero from '../../components/pages/EconomicCalendar/Hero/Hero';
import LiveCalendar from '../../components/pages/EconomicCalendar/LiveCalendar/LiveCalendar';
import EventImpact from '../../components/pages/EconomicCalendar/EventImpact/EventImpact';
import SimpleWorkflow from '../../components/pages/EconomicCalendar/SimpleWorkflow/SimpleWorkflow';
import MacroHighlights from '../../components/pages/EconomicCalendar/MacroHighlights/MacroHighlights';
import BehindTheData from '../../components/pages/EconomicCalendar/BehindTheData/BehindTheData';

const EconomicCalendar = () => {
  return (
    <div>
      <Hero />
      <LiveCalendar />
      <EventImpact />
      <SimpleWorkflow />
      <MacroHighlights />
      <BehindTheData />
    </div>
  );
};

export default EconomicCalendar;
